'use client'
import Image from 'next/image'
import React, { useState } from 'react'
import MobileDrawer from '@/app/(home)/components/MobileDrawer';

export default function MenuButton () {

  const [openMobileDrawer, setOpenMobileDrawer] = useState(false);

  return (
    <>
      <button onClick={() => setOpenMobileDrawer(true)} >
        <Image
          src='/icons/menu.png'
          alt='menu'
          width={32}
          height={32}
          className='w-8'
        />
      </button>
      {openMobileDrawer && <MobileDrawer setOpenDrawer={setOpenMobileDrawer} openDrawer={openMobileDrawer} />}
    </>
  )
}
